import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import handleHospital from "@/services/modules/hospital";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => { 

    const { dateOfBarthConvertToAge } = handleHospital();

    const exportToPDF = (company, investigation, barcode, qrcode, barcodePatient, userName, btnTitle, isHideHeader = false, isHideFooter = false, isDownload = false) => {

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 60, 170 ],
            header: !isHideHeader ? getHeader(company) : {},
            footer: function (currentPage, pageCount) {
                const items = [];

                if (currentPage === pageCount) {
                    items.push(getFooterTop(investigation));
                }
            
                if (!isHideFooter) {
                    items.push(getFooter(userName, qrcode));
                }

                return {
                    margin: [60, 30, 60, 80],
                    layout: 'noBorders',
                    stack: items
                };
            },
            content: getContent(investigation, barcode, barcodePatient, userName, btnTitle),

            styles : {
                header: {
                    fontSize: 16,
                },
                tableHeader: {
                    fontSize: 16,
                },
                tableExample: {
                    fontSize: 10,
                },
            },
            
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },

            info: {
                title: investigation.id
            }
        }

        pushIntoTable(doc, investigation.formattedGenerals, investigation)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        if(isDownload) {
            pdfDocGenerator.download('investigation-report.pdf');
            return;
        }
        pdfDocGenerator.open();
    }

    const calculateAge = (birthday) => {
        const {year, month, day} = dateOfBarthConvertToAge(birthday)
        return `${year}Y, ${month}M, ${day}D`
    }

    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }

    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }

    const getHeader = (company) => {
        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        company.name,
                        'Address: ' + company.address,
                        'Phone: ' + company.phone,
                        'E-mail: ' + company.email
                    ]
                }
            ]
        }
    }

    const getContent = (investigation, barcode, barcodePatient, userName, btnTitle) => {

        return  [
            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                svg: barcodePatient
                            },

                            {
                                text: [
                                    {
                                        text: 'Patient ID: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: investigation.contact_profile.serial_no
                                    }
                                ]
                            },

                            {
                                text: [
                                    {
                                        text: 'Patient Name: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: investigation.contact_profile.full_name
                                    }
                                ]
                            },

                            {
                                text: [
                                    {
                                        text: 'Age: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: `${(investigation.contact_profile && investigation.contact_profile.birthday) ? 
                                            calculateAge(investigation.contact_profile.birthday) : ''}` + 
                                            `${(investigation.contact_profile && investigation.contact_profile.gender) ? 
                                            ' | Gender: ' + investigation.contact_profile.gender : '' }`
                                    }
                                ]
                            },

                            {
                                text: [
                                    {
                                        text: 'Mobile no: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: investigation.contact_profile.mobile_no
                                    }
                                ]
                            },

                            {
                                text: [
                                    {
                                        text: 'Ref By: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: investigation.service_resource.name
                                    }
                                ]
                            }
                            
                        ]
                    },

                    {
                        alignment: 'right',
                        stack: [
                            {
                                svg: barcode
                            },

                            {
                                text: [
                                    {
                                        text: 'INVOICE NO: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },
                                    {
                                        text: investigation.bill_number
                                    }
                                ]
                            },

                            {
                                text: [
                                    {
                                        text: 'INVOICE DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: formatToDdMmYy(investigation.date),
                                    }
                                 ]
                            },
                            
                            {
                                text: [
                                    {
                                        text: 'SL No: ',
                                        bold: true,
                                        margin: [0, 20, 10, 0]
                                    },

                                    {
                                        text: ''
                                    }
                                 ]
                            }
                        ]
                    }
                ]
            },
            {
                text: btnTitle,
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 10, 5],
                bold: true,
                color: 'black',
            }
        ]
    }

    const getFooter = (userName, qrcode) =>{
        return {
            alignment: 'justify',
            columns: [
                {
                    columns: [
                        {
                            svg: qrcode
                        },

                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },

                        {
                            text: userName
                        },

                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    const getFooterTop = (investigation) => {
        return {
            alignment: 'justify',
            margin: [0, 0, 0, 20],
            columns: [
                {
                    width: '50%',
                    stack: [
                        {
                            text: investigation.prepared_by ? investigation.prepared_by.short_description : '',
                            alignment: 'left',
                            width: '50%'
                        }
                    ]
                },
                {
                    width: '50%',
                    alignment: 'right',
                    stack: [
                        {
                            text: investigation.approved_by ? investigation.approved_by.short_description : '',
                            alignment: 'right',
                            width: '50%'
                        }
                    ]
                },
            ]
        }
    }

    const pushIntoTable = (doc, reports, investigation) => {

        const tableHeader = getTableHeader()
        
        const content = {
            style: 'tableExample',
            margin: [0, 10, 0, 0],
            table: {
                widths: ['*', '20%', '10%', '30%'],
                body: []
            },
            layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return '';
                },
                hLineWidth: function (i, node) {
                  return 0.5;
                },
                vLineWidth: function (i, node) {
                  return 0;
                },
                hLineColor: function (i, node) {
                  return '#82868b'; 
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#82868b' : '#dddddd';
                },
            }
        }

        content.table.body.push(tableHeader);
        
        for(const key in reports){
            const tableTitle = getRowTitle(key);
            content.table.body.push(tableTitle);
            setTableContent(reports[key], content);
        }

        doc.content.push(content);
    }

    const setTableContent = (reports, content) => {
        for(const report of reports){
            const row = getRowData(report);
            if (row) {
                content.table.body.push(row);
            }
        }
    }

    const getTableHeader = () => {
        return [
            { text: 'Parameter', bold: true },
            { text: 'Result', bold: true },
            { text: 'Unit', bold: true },
            { text: 'Reference value', bold: true }
        ];
    }
    
    const getRowTitle = (title) => {
        return [ 
            { text: title, bold: true, colSpan: 4, margin: [0, 0, 0, 0]},
            {},
            {},
            {},
        ];
    }
    
    const getRowData = (report) => {
        if(! report.result) return null;

        return [
            { text: report.name, margin: [15, 0, 0, 0]},
            { text: report.result },
            { text: report.unit },
            { text: report.reference_value } 
        ];
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
